import { render, staticRenderFns } from "./ProlongRulesItem.vue?vue&type=template&id=5d905081&scoped=true"
import script from "./ProlongRulesItem.vue?vue&type=script&lang=js"
export * from "./ProlongRulesItem.vue?vue&type=script&lang=js"
import style0 from "./ProlongRulesItem.vue?vue&type=style&index=0&id=5d905081&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d905081",
  null
  
)

export default component.exports